import React from 'react'

function TechSelectSCF() {
  return (
    <embed src="\pdfs\E1.1.1_scf-hightec-triple-s_hi_kpl_02.2016_kr-2.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectSCF